module.exports = __webpack_public_path__ + "static/media/13.d24f7cec.jpeg";